import { render, staticRenderFns } from "./CellGroup.vue?vue&type=template&id=88105132&scoped=true&"
import script from "./CellGroup.vue?vue&type=script&lang=js&"
export * from "./CellGroup.vue?vue&type=script&lang=js&"
import style0 from "./CellGroup.vue?vue&type=style&index=0&id=88105132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88105132",
  null
  
)

export default component.exports